<highcharts-chart *ngIf="data.length"
[Highcharts]="Highcharts"
[options]="chartOptions"
[style.display]="data.length ? '' : 'none'"

></highcharts-chart>
<app-loader *ngIf="loading"></app-loader>
<app-no-widget-data [svgSrc]="'svg/no-widget-data-filters-apply-different.svg'" *ngIf="!data.length && !loading"></app-no-widget-data>
